import React, { useCallback, useEffect } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { useHistory } from "react-router-dom";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as htmlToImage from "html-to-image";

//@material-ui
import {
  Grid,
  Button,
  Box,
  Divider,
  Typography,
  IconButton,
  Container,
  CircularProgress,
} from "@material-ui/core";
import { KeyboardTimePicker } from '@material-ui/pickers';
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Checkbox from "@material-ui/core/Checkbox";
import Rating from "@material-ui/lab/Rating";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Icon from "@material-ui/core/Icon";
import Badge from "@material-ui/core/Badge";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { useSelector } from 'react-redux';
import main_icon from "@assets/images/main_icon.png";
import solid_main_icon from "@assets/images/solid_main_icon.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";

import CancelIcon from "@material-ui/icons/Cancel";

//components
import { SectionHeader, Signature, ImgGallery, DialogConfirm, CustomMenu } from "@components/molecules";
import { update } from "lodash";
import { current } from "@reduxjs/toolkit";

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.alternate.main,
  },
  inner: {
    maxWidth: theme.layout.contentWidth,
    width: "100%",
    margin: "0 auto",
    // padding: theme.spacing(6, 2),
    // [theme.breakpoints.up("sm")]: {
    //   padding: theme.spacing(8, 8),
    // },
    // [theme.breakpoints.up("md")]: {
    //   padding: theme.spacing(12, 8),
    // },
  },
  innerNarrowed: {
    maxWidth: 800,
  },
  requiredBadge: {
    backgroundColor: "#ba1e45",
    color: "white",
  },
  completedBadge: {
    backgroundColor: "#339900",
    color: "white",
  },
  iconButton: {
    marginLeft: theme.spacing(1),
    padding: 0,
    "&:hover": {
      background: "transparent",
    },
  },
  reviewSectionHeader: {
    // backgroundColor: "red"
  },
  questionAnswersHolder: {
    paddingBottom: "20px",
  },
  answers: {
    fontWeight: "bold",
    color: "#115293",
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
  sigImageContainer: {
    width: '30%',
  },
  multiButton: {
    [theme.breakpoints.up("sm")] : {
      width: '25%',
    },
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  viewer: {
    width: window.innerWidth, //the pdf viewer will take up all of the width and height
    height: window.innerHeight,
  },
  stickToCenter: {
    position: 'fixed',
    right: '5%',
    bottom: 10,
    width: '90%',
    zIndex: 9997,
    backgroundColor: 'white',
    [theme.breakpoints.up("sm")]: {
      width: '35%',
      right: '10%',
    },
  },
  loadingBox: {
    border: '2px solid #000',
    boxShadow: 24,
    borderRadius: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    justifyContent: 'space-around'
  }
}));

/**
 * Component to display the alternative sections
 *
 * @param {Object} props
 */
const FormComponent = (props) => {
  const { currentForm, className, submitFormPDF, ...rest } = props;

  const classes = useStyles();
  const history = useHistory();
  //Set variables
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [disableNextButton, setDisableNextButton] = React.useState(true);
  const [questionnaire, setQuestionnaire] = React.useState(null);
  const [requiredFieldsCount, setRequiredFieldsCount] = React.useState(1);
  const [reviewForm, setReviewForm] = React.useState(false);
  const [submitMessage, setSubmitMessage] = React.useState("");
  const [totalRatings, setTotalRatings] = React.useState(0);
  const [totalScore, setTotalScore] = React.useState(0);
  const [openSigModal, setOpenSigModal] = React.useState(false);
  const [failedAgreement, setFailedAgreement] = React.useState(false);
  const [failedAgreementDisableNext, setFailedAgreementDisableNext] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState('');
  const [prevPhoneNumber, setPrevPhoneNumber] = React.useState('');
  const [heightInFeet, setHeightInFeet] = React.useState('');
  const [heightInInches, setHeightInInches] = React.useState('');
  const [checkCurrentPage, setCheckCurrentPage] = React.useState(false);
  const [enableNameField, setEnableNameField] = React.useState(false);

  const { credentials } = useSelector((state) => state);
  const { user } = useSelector((state) => state.user);

  React.useEffect(() => {
    setQuestionnaire(currentForm.questionnaire);
  }, [currentForm]);

  React.useEffect(() => {
    //on page change, scroll to the top
    if (window) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [currentPage, reviewForm]);

  React.useEffect(() => {
    if (!questionnaire) return;

    //check required fields condition
    let allRequiredFields = [];
    allRequiredFields = questionnaire[currentPage].questions.filter(
      (question) => {
        return (
          question.field_type !== "readonly" &&
          question.isRequired === true &&
          (question.answer === null || question.answer.length === 0) ||
          (question.field_type === "input-phone" && question.answer.length < 14) ||
          (question.field_type === "input-height" && (!question.answer.includes("Feet") || !question.answer.includes("Inch")))
        );
      }
    );
    // console.log(allRequiredFields);
    setRequiredFieldsCount(allRequiredFields.length);
    setDisableNextButton(allRequiredFields.length !== 0);
  }, [currentPage, questionnaire]);

  const handleBackToHome = () => {
    history.goBack();
  };

  const handlePageBack = () => {
    setCurrentPage(currentPage - 1);
    setFailedAgreementDisableNext(false);
  };

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
    setCheckCurrentPage(true);
    window.scrollTo(0, 0);
  }

  const checkPageAndQuestion = useCallback(() => {
    if (questionnaire && checkCurrentPage) {
      if (currentPage === 0 || currentPage === 3) {
        if (questionnaire[currentPage].questions[0].questionID === 157 && questionnaire[currentPage].questions[0].answer === "No") {
          setFailedAgreementDisableNext(true);
        } else if (questionnaire[currentPage].questions[0].questionID === 160 && questionnaire[currentPage].questions[0].answer === "No") {
          setFailedAgreementDisableNext(true);
        } else {
          setFailedAgreementDisableNext(false);
        }
      }
      
      questionnaire[currentPage].questions.forEach((question, index) => {
        const date = moment(new Date()).format('MM/DD/YYYY');
        if (question.label.includes("Today's date")) {
          onValueChange(index, date);
        } else if (question.label.includes("Your name") && !question.answer && credentials) {
          if (credentials.employeeProfile.firstName && credentials.employeeProfile.lastName) {
            onValueChange(index, `${credentials.employeeProfile.firstName} ${credentials.employeeProfile.lastName}`);
          } else {
            setEnableNameField(true);
          }
        } else if (question.label.includes("Your job title") && !question.answer && credentials) {
          onValueChange(index, credentials.employeeProfile.jobTitleName)
        } else if (question.label.includes("Sex") && !question.answer && credentials) {
          onValueChange(index, credentials.employeeProfile.gender);
        }
      })
    }
    setCheckCurrentPage(false)
  }, [currentPage, checkCurrentPage]);

  useEffect(() => {
    checkPageAndQuestion();
  }, [currentPage]);

  const onValueChange = (questionIndex, updatedValue, ratingTotal) => {
    if (ratingTotal !== undefined) {
      const tempScore = totalScore + parseInt(updatedValue);
      const tempTotalRatings = totalRatings + ratingTotal;
      setTotalScore(tempScore);
      setTotalRatings(tempTotalRatings);
    }
    let clonedQuestionnaire = [...questionnaire];
    let updatedQuestions = clonedQuestionnaire[currentPage].questions.map(
      (question, currentQuestionIndex) => {
        if (currentQuestionIndex !== questionIndex) return question;
        if (question.questionID === 157 && updatedValue === "No") {
          setAlertMessage({ title: 'Please ensure your privacy', content: `When you're ready to proceed with this form click "Yes".` });
          setFailedAgreement(true);
          setFailedAgreementDisableNext(true);
        } else if (question.questionID === 157 && updatedValue === "Yes") {
          setFailedAgreementDisableNext(false);
        }
        if (question.questionID === 160 && updatedValue === "No") {
          setAlertMessage({ title: 'ATTENTION', content: 'If you made a mistake, please update your selection, if you selection is accurate, please contact your trainer or supervisor.  (Exit Form or Continue)' });
          setFailedAgreement(true);
          setFailedAgreementDisableNext(true);
        } else if (question.questionID === 160 && updatedValue === "Yes") {
          setFailedAgreementDisableNext(false);
        }
        return {
          ...question,
          answer: updatedValue,
        };
      }
    );

    clonedQuestionnaire[currentPage].questions = updatedQuestions;

    //update current form with updated values
    setQuestionnaire(clonedQuestionnaire);
  };

  const handleHeight = (questionIndex, measurement) => {
    let height = '';
    if (measurement.includes("Feet")) {
      setHeightInFeet(measurement);
      height = measurement.concat(', ', heightInInches);
    } else {
      setHeightInInches(measurement);
      height = heightInFeet.concat(', ', measurement);
    }
    onValueChange(questionIndex, height)
  }

  const onMultiSelectValueChange = (questionIndex, updatedValue) => {
    if (updatedValue === undefined) return;

    debugger;
    let clonedQuestionnaire = [...questionnaire];
    let updatedQuestions = clonedQuestionnaire[currentPage].questions.map(
      (question, currentQuestionIndex) => {
        if (currentQuestionIndex !== questionIndex) return question;

        let updatedAnswers = [];
        if (question.answer?.length > 0) {
          let currentAnswers = JSON.parse(question.answer);

          let updatedValueIndex = currentAnswers.indexOf(updatedValue);
          updatedValueIndex === -1
            ? currentAnswers.push(updatedValue)
            : currentAnswers.splice(updatedValueIndex, 1);
          updatedAnswers = currentAnswers;
        } else {
          updatedAnswers.push(updatedValue);
        }

        return {
          ...question,
          answer: JSON.stringify(updatedAnswers),
        };
      }
    );

    clonedQuestionnaire[currentPage].questions = updatedQuestions;

    //update current form with updated values
    setQuestionnaire(clonedQuestionnaire);
  };

  const formatPhoneNumber = (questionIndex, updatedValue) => {
    const currentValue = updatedValue.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;

    if (!prevPhoneNumber || updatedValue.length > prevPhoneNumber.length) {
      setPrevPhoneNumber(currentValue);
      if (cvLength < 4) return onValueChange(questionIndex, currentValue);
      if (cvLength < 7) return onValueChange(questionIndex, `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`);
      const formatted =  `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
      return onValueChange(questionIndex, formatted);
    } else if (updatedValue.length <= prevPhoneNumber.length) {
      setPrevPhoneNumber(currentValue)
      return onValueChange(questionIndex, currentValue);
    }
  }

  const filterNumbersOnly = (questionIndex, updatedValue) => {
    const currentValue = updatedValue.replace(/[^\d]/g, '');
    onValueChange(questionIndex, currentValue);
  }

  //helper methods
  const IsJsonString = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  const formatDate = (date) => {
    return (
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "/" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "/" +
      date.getFullYear()
    );
  };

  const checkMultiSelectValueExists = (questionAnswers, selectValue) => {
    if (questionAnswers === null) return false;

    if (questionAnswers.length > 0 && IsJsonString(questionAnswers)) {
      let currentAnswers = JSON.parse(questionAnswers);
      let selectValueIndex = currentAnswers.indexOf(selectValue);
      return selectValueIndex === -1 ? false : true;
    } else {
      return false;
    }
  };

  const parseMultiSelectValue = (questionAnswers) => {
    if (questionAnswers === null) return "";

    if (questionAnswers.length > 0 && IsJsonString(questionAnswers)) {
      let currentAnswers = JSON.parse(questionAnswers);
      return currentAnswers.toString().replace(/,/g, ", ");
    } else {
      return questionAnswers;
    }
  };

  const parseTimeValue = (questionAnswers) => {
    if (questionAnswers === null) return "";

    let formattedTime;
    if (questionAnswers.length > 0) {
      const index = questionAnswers.indexOf(",");
      formattedTime = questionAnswers.slice(index + 1)
    } else {
      return "";
    }
    return formattedTime;
  }

  const generatePDF = () => {
    htmlToImage
      .toPng(document.getElementById("pdfForm"))
      .then(function (dataUrl) {
        console.log(dataUrl);
        // saveAs(dataUrl, 'my-node2.png');
      });

    html2canvas(document.querySelector("#pdfForm")).then((canvas) => {
      var pdfdoc = new jsPDF("p", "mm");

      var imgData = canvas.toDataURL("image/png");
      var pageHeight = pdfdoc.internal.pageSize.getHeight();
      var pageWidth = pdfdoc.internal.pageSize.getWidth();

      var imgheight =
        (document.querySelector("#pdfForm").clientHeight * 25.4) / 96; //px to mm
      var pagecount = Math.ceil(imgheight / pageHeight);
      pagecount = pagecount + 3; //add extra pages just incase we need additional space
      /* add initial page */
      pdfdoc.addPage("l", "mm", "a4");
      pdfdoc.addImage(
        imgData,
        "PNG",
        2,
        0,
        pageWidth - 4,
        0,
        undefined,
        "FAST"
      );

      /* add extra pages if the div size is larger than a a4 size */
      if (pagecount > 0) {
        var j = 1;
        while (j < pagecount) {
          pdfdoc.addPage("l", "mm", "a4");
          pdfdoc.addImage(
            imgData,
            "PNG",
            2,
            -(j * pageHeight),
            pageWidth - 4,
            0,
            undefined,
            "FAST"
          );
          j++;
        }
      }

      pdfdoc.deletePage(1); // first page is blank, not sure why so deleting it for now

      //pdfdoc.save("final.pdf"); //Download the rendered PDF.
      return pdfdoc.output("datauristring");
    });
  };

  const saveAs = (blob, fileName) => {
    var elem = window.document.createElement("a");
    elem.href = blob;
    elem.download = fileName;
    elem.style = "display:none;";
    (document.body || document.documentElement).appendChild(elem);
    if (typeof elem.click === "function") {
      elem.click();
    } else {
      elem.target = "_blank";
      elem.dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        })
      );
    }
    URL.revokeObjectURL(elem.href);
    elem.remove();
  };

  const submitPDF = () => {

    try
    {
      setSubmitMessage("Generating PDF...")
      if (currentForm.formKey === "MDCSCRNDCT") {
        const doc = new jsPDF("p", "pt");
        const pageHeight = doc.internal.pageSize.height;
        const pageWidth = doc.internal.pageSize.width;
        let y = 30;          

        doc.addImage(solid_main_icon, 'png', 15, 30, 125, 40);
        doc.text(300, y, `${user.firstName} ${user.lastName}`);
        y+=15;
        doc.text(300, y, `Number: ${user.employeeNumber}`);
        y+=15;
        doc.text(300, y, `Email: ${user.email}`);
        y+=15;
        doc.text(300, y, `Date: ${moment(new Date()).format('MM/DD/YYYY')}`);
        y+=30;
        doc.setFontSize(20);
        doc.setFont(undefined, 'bold');
        doc.text(pageWidth / 2, y, currentForm.formName, {align: 'center'});

        questionnaire.length > 0 && questionnaire.map((page) => {
          if (page.screenKey === 'cover_warning1' || page.screenKey === 'cover_warning3') {
            return;
          }
          if (y > pageHeight) {
            doc.addPage();
            y = 0;
          }

          if (page.title) {
            y+=30;
            if (y > pageHeight) {
              doc.addPage();
              y = 30;
            }
            doc.setFontSize(16);
            doc.setFont(undefined, 'bold');
            doc.text(pageWidth / 2, y, page.title, {align: 'center'});
            y+=15;
          }
            page.questions.length > 0 && page.questions.map((question) => {
              if (y > pageHeight) {
                doc.addPage();
                y = 0;
              }
                const splitLabel = doc.splitTextToSize(question.label, 500);
                if (y + 30 * splitLabel.length > pageHeight) {
                  doc.addPage();
                  y = 0;
                }

                doc.setFontSize(14);
                doc.setFont(undefined, 'normal');
                const lastIndex = splitLabel[splitLabel.length - 1];
                let indent = false;
                if (question.field_type !== 'readonly' && lastIndex[lastIndex.length - 1] !== "?") {
                  splitLabel[splitLabel.length - 1] = `${splitLabel[splitLabel.length - 1]}:`;
                  y+=20;
                  if (isNaN(question.label[0])) {
                    doc.text(60, y, splitLabel);
                    indent = true;
                  } else {
                    doc.text(15, y, splitLabel);
                  }
                } else {
                  y+=20;
                  doc.text(15, y, splitLabel);
                }
                if (!question.answer) {
                  const halfLength = splitLabel.length / 2;
                  y+=30 * halfLength;
                }
                if (y > pageHeight) {
                  doc.addPage();
                  y = 0;
                }

                let x = 75;
                if (question.answer && !question.answer.includes('base64')) {
                  if (y !== 0) {
                    y+=30 * splitLabel.length;
                  }
                  doc.setFontSize(12);
                  doc.setFont(undefined, 'bold');
                  const textWidth = doc.getStringUnitWidth(splitLabel[splitLabel.length - 1]);
                  const addMoreWidth = indent ? 45 : 0;
                  const width = textWidth * 14 + addMoreWidth;
                  if (question.screenTitle && width < 500 && question.field_type !== 'textarea') {
                    let space = 0;
                    if (width < 175) {
                      space = 20;
                    } else if (width >= 175 && width <= 320) {
                      space = 10;
                    } else  if (width > 320 && width <= 375) {
                      space = -5;
                    } else {
                      space = -10;
                    }
                    x = width + space;
                    const length = splitLabel.length;
                    if (length === 1) {
                      if (y > 30) {
                        y-= 30;
                      }
                      question.answer !== null && doc.text(x, y, question.answer);
                      y+= 10;
                    } else {
                      if (y > 30) {
                        y-=(30 * length) - (16 * (length - 1));
                      }
                      question.answer !== null && doc.text(x, y, question.answer);
                      y+=(10 * length) - (16 * (length - 1));
                    }
                  } else if (question.field_type === 'textarea') {
                    const splitText = doc.splitTextToSize(question.answer, 500);
                    if (y + 30 * splitText.length > pageHeight) {
                      doc.addPage();
                      y = 20;
                    }
                    doc.setFontSize(12);
                    doc.setFont(undefined, 'bold');
                    doc.text(x, y, splitText);
                    y+=30 * (splitText.length / 2);
                  } else {
                    question.answer !== null && doc.text(x, y, question.answer);
                    y+=10;
                  }
                } else if (question.answer && question.answer.includes('base64')) {
                  y+=10;
                  doc.addImage(question.answer, 'png', x, y, 75, 24);
                  y+=30;
                }
              } 
            ).join('')
        }).join('')
        setSubmitMessage("Submitting...");
        submitFormPDF(doc.output("datauristring")).then((result) => {
          console.log('result: ', result)
        if(!result) {
          setSubmitMessage("");
        }
      });
      } else {
        setSubmitMessage("Submitting...");
        let formContents = [];
        questionnaire.length > 0 && questionnaire.map((page) => {
          if (page.questions.length > 0) {
            page.questions.length > 0 && page.questions.map((currentAnswer) => {
              if (currentAnswer.label === "Total Score") {
                return;
              }
              if (currentAnswer.field_type.includes("rating")) {
                formContents.push({ "label": currentAnswer.label, "value": currentAnswer?.answer ? currentAnswer.answer : "0" });
              } else {
                formContents.push({ "label": currentAnswer.label, "value": currentAnswer.answer });
              }
            })
          }
        })
        submitFormPDF(null, formContents).then((result) => {
        if(!result) {
          setSubmitMessage("");
        }
      });
    }
  }
    catch (ex) {
      console.log(ex)
      setSubmitMessage("oops");
    }
  }

  const generateTestPDF = () => {
    const doc = new jsPDF("p", "pt");
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    let y = 30;          

    doc.addImage(solid_main_icon, 'png', 15, 30, 125, 40);
    doc.text(300, y, `${user.firstName} ${user.lastName}`);
    y+=15;
    doc.text(300, y, `Number: ${user.employeeNumber}`);
    y+=15;
    doc.text(300, y, `Email: ${user.email}`);
    y+=15;
    doc.text(300, y, `Date: ${moment(new Date()).format('MM/DD/YYYY')}`);
    y+=30;
    doc.setFontSize(20);
    doc.setFont(undefined, 'bold');
    doc.text(pageWidth / 2, y, currentForm.formName, {align: 'center'});

    questionnaire.length > 0 && questionnaire.map((page) => {
      if (page.screenKey === 'cover_warning1' || page.screenKey === 'cover_warning3') {
        return;
      }
      if (y > pageHeight) {
        doc.addPage();
        y = 0;
      }

      if (page.title) {
        y+=30;
        if (y > pageHeight) {
          doc.addPage();
          y = 30;
        }
        doc.setFontSize(16);
        doc.setFont(undefined, 'bold');
        doc.text(pageWidth / 2, y, page.title, {align: 'center'});
        y+=15;
      }
        page.questions.length > 0 && page.questions.map((question) => {
          if (y > pageHeight) {
            doc.addPage();
            y = 0;
          }
            const splitLabel = doc.splitTextToSize(question.label, 500);
            if (y + 30 * splitLabel.length > pageHeight) {
              doc.addPage();
              y = 0;
            }

            doc.setFontSize(14);
            doc.setFont(undefined, 'normal');
            const lastIndex = splitLabel[splitLabel.length - 1];
            let indent = false;
            if (question.field_type !== 'readonly' && lastIndex[lastIndex.length - 1] !== "?") {
              splitLabel[splitLabel.length - 1] = `${splitLabel[splitLabel.length - 1]}:`;
              y+=20;
              if (isNaN(question.label[0])) {
                doc.text(60, y, splitLabel);
                indent = true;
              } else {
                doc.text(15, y, splitLabel);
              }
            } else {
              y+=20;
              doc.text(15, y, splitLabel);
            }
            if (!question.answer) {
              const halfLength = splitLabel.length / 2;
              y+=30 * halfLength;
            }
            if (y > pageHeight) {
              doc.addPage();
              y = 0;
            }

            let x = 75;
            if (question.answer && !question.answer.includes('base64')) {
              if (y !== 0) {
                y+=30 * splitLabel.length;
              }
              doc.setFontSize(12);
              doc.setFont(undefined, 'bold');
              const textWidth = doc.getStringUnitWidth(splitLabel[splitLabel.length - 1]);
              const addMoreWidth = indent ? 45 : 0;
              const width = textWidth * 14 + addMoreWidth;
              if (question.screenTitle && width < 500 && question.field_type !== 'textarea') {
                let space = 0;
                if (width < 175) {
                  space = 20;
                } else if (width >= 175 && width <= 320) {
                  space = 10;
                } else  if (width > 320 && width <= 375) {
                  space = -5;
                } else {
                  space = -10;
                }
                x = width + space;
                const length = splitLabel.length;
                if (length === 1) {
                  if (y > 30) {
                    y-= 30;
                  }
                  question.answer !== null && doc.text(x, y, question.answer);
                  y+= 10;
                } else {
                  if (y > 30) {
                    y-=(30 * length) - (16 * (length - 1));
                  }
                  question.answer !== null && doc.text(x, y, question.answer);
                  y+=(10 * length) - (16 * (length - 1));
                }
              } else if (question.field_type === 'textarea') {
                const splitText = doc.splitTextToSize(question.answer, 500);
                if (y + 30 * splitText.length > pageHeight) {
                  doc.addPage();
                  y = 20;
                }
                doc.setFontSize(12);
                doc.setFont(undefined, 'bold');
                doc.text(x, y, splitText);
                y+=30 * (splitText.length / 2);
              } else {
                question.answer !== null && doc.text(x, y, question.answer);
                y+=10;
              }
            } else if (question.answer && question.answer.includes('base64')) {
              y+=10;
              doc.addImage(question.answer, 'png', x, y, 75, 24);
              y+=30;
            }
          } 
        ).join('')
    }).join('')
    return doc.output("dataurlnewwindow");
  } 

    const handleSelectNoToAll = () => {
      questionnaire[currentPage].questions.forEach((question, index) => {
        if (question.field_type !== 'readonly') {
          onValueChange(index, "No");
        }
      });
    }

  return (
    <section
      className={clsx("section-alternate", classes.root, className)}
      {...rest}
    >
      {currentForm && currentForm.formName && (
        <SectionHeader title={currentForm.formName} />
      )}
      

      {reviewForm && (
        <>
          {/* <button onClick={generatePDF}>Generate pdf</button> */}
            <Grid item xs={12}>
              <SectionHeader
                ctaGroup={[
                  <Button
                    variant="outlined"
                    color="primary"
                    size={"large"}
                    disabled={currentPage === 0 || submitMessage.length > 0}
                    onClick={() => setReviewForm(false)}
                  >
                    Back
                  </Button>,
                  <Button
                    variant="contained"
                    color="primary"
                    size={"large"}
                    disabled={submitMessage.length > 0}
                    onClick={() => submitPDF()}
                  >
                    {submitMessage.length > 0 ? <Typography variant="button">{submitMessage} <CircularProgress color="inherit" size={18} /></Typography> : "Submit"}
                  </Button>,
                ]}
                align={"right"}
                disableGutter
              />
            </Grid>

          <div
            id="pdfForm"
            style={{
              padding: "4px",
              width: "80%",
              height: "auto",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >

            {questionnaire &&
              questionnaire.map((section, sectionIndex) => (
                <div className="htmlToCanvasVis">
                  <Grid container spacing={1}>
                    <Grid item xs={9}>
                      <Box m={4} className={classes.reviewSectionHeader}>
                        <SectionHeader
                          title={section && section.title ? section.title : ""}
                          align={"left"}
                          disableGutter
                        />
                      </Box>
                    </Grid>

                    <Grid container spacing={4}>
                      <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                          {section &&
                            section.questions.map((question, questionIndex) => (
                              <Grid item xs={12} key={questionIndex}>
                                {/* {(question.answer === null || question.answer === "") &&
                              question.isRequired &&
                              question.field_type !== "readonly" && (
                                <Badge
                                  classes={{ badge: classes.requiredBadge }}
                                  style={{marginRight: "5px"}}
                                  variant="dot"
                                />
                              )} */}
                                <div className={classes.questionAnswersHolder}>
                                  {"  "}
                                  {question.label}
                                  {/* {question.answer?.length !== 0 && question.answer} */}
                                  <br />
                                  {
                                    {
                                      input: (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      "input-int": (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      "input-height": (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      "input-phone": (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      textarea: (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      multiselectlist: (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer !== null &&
                                            parseMultiSelectValue(
                                              question.answer
                                            )}
                                        </div>
                                      ),
                                      datefield: (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      time: (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer !== null &&
                                            parseTimeValue(question.answer)}
                                        </div>
                                      ),
                                      radiobuttonlist: (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer !== null &&
                                            parseMultiSelectValue(
                                              question.answer
                                            )}
                                        </div>
                                      ),
                                      textfield: (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      checkbox: (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      "rating-3": (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      "rating-4": (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      "rating-5": (
                                        <div className={classes.answers}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                      "total-rating": (
                                        <div className={clsx(classes.answers, classes.center)}>
                                          {question.answer?.length !== 0 &&
                                            question.answer}
                                        </div>
                                      ),
                                    }[question.field_type]
                                  }
                                </div>
                              </Grid>
                            ))}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </div>
              ))}
          </div>
          <Grid item xs={12}>
            <SectionHeader
              ctaGroup={[
                <Button
                  variant="outlined"
                  color="primary"
                  size={"large"}
                  disabled={currentPage === 0 || submitMessage.length > 0}
                  onClick={() => setReviewForm(false)}
                >
                  Back
                </Button>,
                <Button
                  variant="contained"
                  color="primary"
                  size={"large"}
                  disabled={submitMessage.length > 0}
                  onClick={() => submitPDF()}
                >
                  {submitMessage.length > 0 ? <Typography variant="button">{submitMessage} <CircularProgress color="inherit" size={18} /></Typography> : "Submit"}
                </Button>,
              ]}
              align={"right"}
              disableGutter
            />
          </Grid>
        </>
      )}
      {!reviewForm && (
        <div className={clsx("section-alternate__content", classes.inner)}>
          {/* <Button variant="contained" color="primary" onClick={generateTestPDF}>Generate pdf</Button> */}
          <Grid container spacing={1}>
            <Grid item xs={9}>
              <Box m={1} className={classes.sectionHeader}>
                <SectionHeader
                  title={
                    questionnaire && questionnaire[currentPage].title
                      ? questionnaire[currentPage].title
                      : ""
                  }
                  align={"left"}
                  disableGutter
                  subtitle={
                    questionnaire
                      ? `Page ${currentPage + 1} of ${questionnaire.length}`
                      : ""
                  }
                />

                {/* dev testing button only! Keep button commented out for production */}
                {currentPage === 5 && (user.employeeNumber === 'C8102122' || user.employeeNumber === '26004400' || user.employeeNumber === '1986211') && (
                  <Button variant="contained" color="primary" onClick={() => handleSelectNoToAll()}>Set All to No</Button>
                )}

              </Box>
            </Grid>

            {currentPage ===
              (questionnaire && questionnaire.length - 1) && currentForm.formKey === "MDCSCRNDCT" && (
                <Grid item xs={12}>
                  <SectionHeader
                    ctaGroup={[
                      <Button
                        variant="outlined"
                        color="primary"
                        size={"large"}
                        disabled={currentPage === 0 || submitMessage.length > 0}
                        onClick={() => handlePageBack()}
                      >
                        Back
                      </Button>,
                      <Button
                        variant="contained"
                        color="primary"
                        size={"large"}
                        disabled={submitMessage.length > 0}
                        onClick={() => submitPDF()}
                      >
                        {submitMessage.length > 0 ? <Typography variant="button">{submitMessage}</Typography> : "Submit"}
                      </Button>,
                    ]}
                    align={"right"}
                    disableGutter
                  />
                </Grid>
            )}

            <Grid container spacing={4}>
              {questionnaire &&
                questionnaire[currentPage].questions.map(
                  (question, questionIndex) => (
                    <Grid item xs={12}>
                      <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                          {question.field_type !== "readonly" && question.field_type !== "input-phone" && question.field_type !== 'input-height' && question.isRequired && (
                            (question.answer === null ||
                            question.answer === "") ||
                            failedAgreementDisableNext
                             ? (
                              <Badge
                                classes={{ badge: classes.requiredBadge }}
                                style={{ marginRight: "5px" }}
                                variant="dot"
                              />
                            )
                            : <Badge
                                classes={{ badge: classes.completedBadge }}
                                style={{ marginRight: "5px" }}
                                variant="dot"
                              />
                          )}
                          {question.field_type === "input-phone" && question.isRequired && (
                            (question.answer === null ||
                            question.answer.length < 14) ||
                            failedAgreementDisableNext
                             ? (
                              <Badge
                                classes={{ badge: classes.requiredBadge }}
                                style={{ marginRight: "5px" }}
                                variant="dot"
                              />
                            )
                            : <Badge
                                classes={{ badge: classes.completedBadge }}
                                style={{ marginRight: "5px" }}
                                variant="dot"
                              />
                          )}
                          {question.field_type === "input-height" && question.isRequired && (
                            question.answer === null ||
                            (!question.answer.includes("Feet") || !question.answer.includes("Inch")) ||
                            failedAgreementDisableNext
                             ? (
                              <Badge
                                classes={{ badge: classes.requiredBadge }}
                                style={{ marginRight: "5px" }}
                                variant="dot"
                              />
                            )
                            : <Badge
                                classes={{ badge: classes.completedBadge }}
                                style={{ marginRight: "5px" }}
                                variant="dot"
                              />
                          )}
                          {"  "}
                          {question.label}
                          {/* {question.answer?.length !== 0 && question.answer} */}
                          <br />
                          {
                            {
                              input: (
                                !checkCurrentPage && (
                                  <TextField
                                    variant="outlined"
                                    disabled={question.isViewOnly && !enableNameField}
                                    placeholder={
                                      question.placeholder?.length !== 0 &&
                                      question.placeholder
                                    }
                                    onChange={(e) =>
                                      onValueChange(questionIndex, e.target.value)
                                    }
                                    fullWidth={true}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={
                                      question.answer?.length !== 0 ?
                                      question.answer : ''
                                    }
                                  />
                                )
                              ),
                              "input-int": (
                                <TextField
                                  inputProps={{ inputMode: 'numeric' }}
                                  variant="outlined"
                                  placeholder={
                                    question.placeholder?.length !== 0 &&
                                    question.placeholder
                                  }
                                  onChange={(e) =>
                                    filterNumbersOnly(questionIndex, e.target.value)
                                  }
                                  fullWidth={true}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={
                                    question.answer?.length !== 0 ?
                                    question.answer : ''
                                  }
                                />
                              ),
                              "input-height": (
                                <div className={classes.multiButton}>
                                  <CustomMenu 
                                    title="Select Feet" 
                                    options={[
                                      {label: "3 Feet"},
                                      {label: "4 Feet"},
                                      {label: "5 Feet"},
                                      {label: "6 Feet"},
                                      {label: "7 Feet"},
                                      {label: "8 Feet"},
                                    ]}
                                    handleChange={(e) => handleHeight(questionIndex, e.target.value)}
                                    value={heightInFeet}
                                  />
                                  <CustomMenu 
                                    title="Select Inches" 
                                    options={[
                                      {label: "0 Inches"},
                                      {label: "1 Inch"},
                                      {label: "2 Inches"},
                                      {label: "3 Inches"},
                                      {label: "4 Inches"},
                                      {label: "5 Inches"},
                                      {label: "6 Inches"},
                                      {label: "7 Inches"},
                                      {label: "8 Inches"},
                                      {label: "9 Inches"},
                                      {label: "10 Inches"},
                                      {label: "11 Inches"},
                                    ]}
                                    handleChange={(e) => handleHeight(questionIndex, e.target.value)}
                                    value={heightInInches}
                                  />
                                </div>
                              ),
                              "input-phone": (
                                <TextField
                                  // type="number"
                                  inputProps={{ inputMode: 'numeric' }}
                                  variant="outlined"
                                  placeholder={
                                    question.placeholder?.length !== 0 &&
                                    question.placeholder
                                  }
                                  onChange={(e) =>
                                    formatPhoneNumber(questionIndex, e.target.value)
                                  }
                                  fullWidth={true}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={
                                    question.answer?.length !== 0 ?
                                    question.answer : ''
                                  }
                                />
                              ),
                              textarea: (
                                <TextField
                                  disabled={!question.isEditable}
                                  variant="outlined"
                                  placeholder={
                                    question.placeholder?.length !== 0 &&
                                    question.placeholder
                                  }
                                  onChange={(e) => 
                                    onValueChange(questionIndex, e.target.value)
                                  }
                                  fullWidth={true}
                                  multiline
                                  rows={4}
                                  value={
                                    question.answer?.length !== 0 ?
                                    question.answer : ''
                                  }
                                />
                              ),
                              multiselectlist: (
                                <RadioGroup
                                  name="radio-buttons-group_multi"
                                  onClick={(e) =>
                                    onMultiSelectValueChange(
                                      questionIndex,
                                      e.target.value
                                    )
                                  }
                                >
                                  {question.select_options !== null &&
                                    JSON.parse(
                                      question.select_options
                                    ).map((selectOption, selectOptionIndex) => (
                                      <FormControlLabel
                                        key={selectOptionIndex}
                                        checked={checkMultiSelectValueExists(
                                          question.answer,
                                          selectOption
                                        )}
                                        value={selectOption}
                                        control={<Radio color="primary" />}
                                        label={selectOption}
                                      />
                                    ))}
                                </RadioGroup>
                              ),
                              datefield: (
                                <>
                                  {question.answer?.length !== 0 &&
                                  question.answer ? (
                                    <>
                                      <Grid container direction={"row"}>
                                        {question.answer}
                                        <IconButton
                                          className={classes.iconButton}
                                          aria-label="Cancel"
                                          onClick={() =>
                                            onValueChange(questionIndex, "")
                                          }
                                        >
                                          <CancelIcon />
                                        </IconButton>
                                      </Grid>
                                    </>
                                  ) : (
                                    <DatePicker
                                      onChange={(date) =>
                                        onValueChange(
                                          questionIndex,
                                          formatDate(date)
                                        )
                                      }
                                    />
                                  )}
                                </>
                              ),
                              time: (
                                <KeyboardTimePicker
                                  margin="normal"
                                  id="time-picker"
                                  label="Time picker"
                                  value={
                                    question.answer?.length !== 0 &&
                                    question.answer
                                  }
                                  onChange={(time) =>
                                    onValueChange(questionIndex, moment
                                      .utc(time, 'MM/DD/YYYY hh:mm:ss a')
                                      .local()
                                      .format('MMMM DD, hh:mm A'))
                                  }
                                  KeyboardButtonProps={{
                                    'aria-label': 'change time',
                                  }}
                                  keyboardIcon={
                                    <FontAwesomeIcon
                                      icon={faClock}
                                      size="1x"
                                    />
                                  }
                                />
                              ),
                              radiobuttonlist: (
                                <RadioGroup
                                  defaultValue={
                                    question.answer?.length !== 0 &&
                                    question.answer
                                  }
                                  name="radio-buttons-group"
                                  value={
                                    question.answer?.length !== 0 &&
                                    question.answer
                                  }
                                  onChange={(e) =>
                                    onValueChange(questionIndex, e.target.value)
                                  }
                                  className={classes.multiButton}
                                >
                                  {question.select_options !== null &&
                                    JSON.parse(
                                      question.select_options
                                    ).map((selectOption, selectOptionIndex) => (
                                      <FormControlLabel
                                        key={selectOptionIndex}
                                        value={selectOption.value}
                                        control={<Radio color="primary" />}
                                        label={selectOption.label}
                                      />
                                    ))}
                                </RadioGroup>
                              ),
                              textfield: (
                                <TextField
                                  id={question.id}
                                  label={question.label}
                                  placeholder={
                                    question.placeholder || question.label
                                  }
                                  value={question.answer}
                                  required={question.isRequired}
                                  variant="outlined"
                                  fullWidth={true}
                                  focused={question.isRequired}
                                  color={
                                    question.isRequired &&
                                    question.answer?.length === 0 &&
                                    "warning"
                                  }
                                  sx={{
                                    marginRight: 5,
                                    width: true ? "100%" : "45%",
                                  }}
                                  onChange={(e) =>
                                    onValueChange(questionIndex, e.target.value)
                                  }
                                />
                              ),
                              checkbox: (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      onClick={(e) =>
                                        onValueChange(
                                          questionIndex,
                                          e.target.value
                                        )
                                      }
                                      sx={{
                                        color: question.isRequired
                                          ? "red"
                                          : "grey",
                                      }}
                                    />
                                  }
                                  id={question.questionID}
                                  label={question.label}
                                />
                              ),
                              "rating-3": (
                                <Rating
                                  key={question.label}
                                  max={3}
                                  onChange={(e) =>
                                    onValueChange(
                                      questionIndex,
                                      e.target.value,
                                      3
                                    )
                                  }
                                  sx={{
                                    color: question.isRequired
                                      ? "red"
                                      : "grey",
                                  }}
                                />
                              ),
                              "rating-4": (
                                <Rating
                                  key={question.label}
                                  max={4}
                                  onChange={(e) =>
                                    onValueChange(
                                      questionIndex,
                                      e.target.value,
                                      4
                                    )
                                  }
                                  sx={{
                                    color: question.isRequired
                                      ? "red"
                                      : "grey",
                                  }}
                                />
                              ),
                              "rating-5": (
                                <Rating
                                  key={question.label}
                                  max={5}
                                  onChange={(e) =>
                                    onValueChange(
                                      questionIndex,
                                      e.target.value,
                                      5
                                    )
                                  }
                                  sx={{
                                    color: question.isRequired
                                      ? "red"
                                      : "grey",
                                  }}
                                />
                              ),
                              "total-rating": (
                                <Typography variant="h6">{totalScore} / {totalRatings}</Typography>
                              ),
                              signature: (
                                <>
                                {question.answer ? 
                                  <Button variant="outlined" color="primary" onClick={() => setOpenSigModal(true)}>Redo Signature</Button> :
                                  <Button variant="outlined" color="primary" onClick={() => setOpenSigModal(true)}>Sign here</Button>
                                }
                                {question.answer && (
                                  <Container className={classes.sigImageContainer}>
                                    <ImgGallery images={[{ original: question.answer }]} showNav={false} fullscreen={false} />
                                  </Container>
                                )}
                                </>
                                ),
                              }[question.field_type]
                            }
                            {openSigModal && (
                              <Signature 
                                question={question} 
                                questionIndex={questionIndex} 
                                onValueChange={onValueChange}
                                openSigModal={openSigModal}
                                setOpenSigModal={setOpenSigModal}
                              />
                            )}
                        </CardContent>
                      </Card>
                    </Grid>
                  )
                )}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <SectionHeader
              ctaGroup={[
                <Button
                  variant="outlined"
                  // disabled={currentPage === 0}
                  color="primary"
                  size={"large"}
                  onClick={currentPage === 0 ? () => handleBackToHome() : () => handlePageBack()}
                >
                  Back
                </Button>,
                <Badge
                  classes={{ badge: classes.requiredBadge }}
                  badgeContent={requiredFieldsCount}
                >
                  {currentPage !==
                    (questionnaire && questionnaire.length - 1) && (
                    <Button
                      variant="contained"
                      disabled={
                        currentPage ===
                          (questionnaire && questionnaire.length - 1) ||
                        disableNextButton ||
                        failedAgreementDisableNext
                      }
                      color="primary"
                      size={"large"}
                      onClick={() => handleNextPage()}
                    >
                      Next
                    </Button>
                  )}
                  {currentPage ===
                    (questionnaire && questionnaire.length - 1) && (
                    // <Button
                    //   variant="contained"
                    //   color="primary"
                    //   size={"large"}
                    //   onClick={() => setReviewForm(true)}
                    // >
                    //   Review
                    // </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        size={"large"}
                        disabled={submitMessage.length > 0}
                        onClick={() => submitPDF()}
                      >
                      {submitMessage.length > 0 ? <Typography variant="button">{submitMessage}</Typography> : "Submit"}
                    </Button>
                  )}
                </Badge>,
              ]}
              align={"right"}
              disableGutter
            />
          </Grid>
        </div>
      )}
      {submitMessage.length > 0 && (
        <div className={classes.stickToCenter}>
          <div className={classes.loadingBox}>
            <Typography variant="subtitle2" color="primary">Submitting your form. This process may take a minute or two...</Typography>
            <CircularProgress size={30} color="primary" />
          </div>
        </div>
      )}
      <DialogConfirm {...{
          dialogProps: {
            open: failedAgreement,
          },
          okBtnText: 'Continue',
          cancelBtnText: 'Exit Form',
          title: alertMessage.title,
          content: alertMessage.content,
          onOkClickHandler: () => setFailedAgreement(false),
          onCancelClickHandler: () => handleBackToHome()
        }}
      />
    </section>
  );
};

FormComponent.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Children to placed inside the section
   */
  children: PropTypes.node,
  /**
   * Should show narrow sections
   */
  innerNarrowed: PropTypes.bool,
};

export default FormComponent;
